import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sandbar-coffee/artifacts/c3buqejl_Larger%20SBC%20Logo%20transparent.png";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <>
      <header className="header-nav" data-testid="site-header">
        <a href="/#home" data-testid="header-logo-link">
          <img src={LOGO_URL} alt="Sandbar Coffee" className="logo" />
        </a>
        <nav className="nav-links">
          <a href="/#about" data-testid="nav-about">About</a>
          <a href="/#services" data-testid="nav-events">Events</a>
          <a href="/#packages" data-testid="nav-services">Services</a>
          <Link to="/menu" data-testid="nav-menu">What We Serve</Link>
          <a href="/#faq" data-testid="nav-faq">FAQ</a>
          <Link to="/book" data-testid="nav-book-event">Get a Quote</Link>
        </nav>
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </header>

      <div className={`mobile-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={closeMobileMenu}></div>
      <nav className={`mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-links">
          <li><a href="/#about" onClick={closeMobileMenu} data-testid="mobile-nav-about">About</a></li>
          <li><a href="/#services" onClick={closeMobileMenu} data-testid="mobile-nav-events">Events</a></li>
          <li><a href="/#packages" onClick={closeMobileMenu} data-testid="mobile-nav-services">Services</a></li>
          <li><Link to="/menu" onClick={closeMobileMenu} data-testid="mobile-nav-menu">What We Serve</Link></li>
          <li><a href="/#faq" onClick={closeMobileMenu} data-testid="mobile-nav-faq">FAQ</a></li>
          <li><Link to="/book" onClick={closeMobileMenu} data-testid="mobile-nav-book-event">Get a Quote</Link></li>
        </ul>
      </nav>
    </>
  );
};
